import apiClient from '@/lib/api/axios';

/** Field name must match backend `DESKTOP_ARTIFACT_UPLOAD_FIELD`. */
export const DESKTOP_ARTIFACT_UPLOAD_FIELD = 'file';

/** Large installer/plugin uploads need a longer timeout than default API calls. */
const ARTIFACT_UPLOAD_TIMEOUT_MS = 30 * 60 * 1000;

/**
 * Upload a file through the backend API (server writes to MinIO via internal endpoint).
 * Progress is reported as 0–100 when Content-Length is known.
 */
export async function postArtifactMultipartUpload<T>(params: {
  path: string;
  file: File;
  query: Record<string, string | undefined>;
  onProgress?: (percent: number) => void;
}): Promise<T> {
  const { path, file, query, onProgress } = params;
  const form = new FormData();
  form.append(DESKTOP_ARTIFACT_UPLOAD_FIELD, file);
  const paramsQuery = { ...query, fileName: query.fileName ?? file.name };

  const { data } = await apiClient.post<T>(path, form, {
    params: paramsQuery,
    timeout: ARTIFACT_UPLOAD_TIMEOUT_MS,
    // Let the browser set multipart boundary (explicit Content-Type without boundary stalls large uploads).
    headers: { 'Content-Type': undefined },
    onUploadProgress: event => {
      if (!onProgress) return;
      const total = event.total ?? file.size;
      if (total <= 0) return;
      const loaded = event.loaded ?? 0;
      onProgress(Math.min(100, Math.round((loaded / total) * 100)));
    },
  });
  return data;
}
